import formatCurrency from "../../../utils/formatCurrency";

export default function PageNumberInput({ value, setValue }) {
    const handleAdd = () => {
        setValue([...value, { page_number_id: "", price: 0 }]);
    };

    const handleChange = (index, field, val) => {
        const updated = [...value];
        updated[index][field] = val;
        setValue(updated);
    };

    const handleRemove = (index) => {
        const updated = value.filter((_, i) => i !== index);
        setValue(updated);
    };

    return (
        <div className="col-sm-12 col-xs-12 mt-4">
            <label><strong>Jumlah Halaman + Harga Tambahan</strong></label>
            {value.map((row, index) => (
                <div key={index} style={{ display: "flex", gap: "1rem", marginBottom: "0.5rem" }}>
                    <input
                        type="number"
                        placeholder="Jumlah Halaman"
                        value={row.page_number_id}
                        onChange={(e) => handleChange(index, "page_number_id", parseInt(e.target.value))}
                        style={{ width: "150px" }}
                        className="form-control py-11"
                    />
                    <input
                        type="text"
                        placeholder="Harga Tambahan"
                        value={formatCurrency(row.price)}
                        onChange={(e) => handleChange(index, "price", e.target.value)}
                        style={{ width: "150px" }}
                        className="form-control py-11"
                        step="0.01"
                    />
                    <button type="button" onClick={() => handleRemove(index)} style={{ color: "red" }}>Hapus</button>
                </div>
            ))}
            <button type="button" onClick={handleAdd}>+ Tambah Jumlah Halaman</button>
        </div>
    );
}
